// extracted by mini-css-extract-plugin
module.exports = {"label":"UpdateUserPage_label__1Tg-0"};